import React from 'react'
import { ButtonRedirect } from '../../components/ButtonRedirect'
import { ContainerContent, ContainerTemplate } from '../../components/Containers'
import { Header } from '../../components/Header'
import { Icon } from '../../components/Icon'
import { Title } from '../../components/Title'

export const TemplateSuccess: React.FC = () => {
  return (
    <ContainerTemplate>
      <Header text="Parabéns" />
      <ContainerContent style={{ justifyContent: 'center' }}>
        <Title text="Seu currículo foi enviado com sucesso, fique atento a sua caixa de e-mails!" />
        <Icon text="Ícone de sucesso" path="/images/icons/iconSuccess.svg" />
        <ButtonRedirect link="/" nameButton="Voltar a ver as vagas" />
      </ContainerContent>
    </ContainerTemplate>
  )
}
